// extracted by mini-css-extract-plugin
module.exports = {"component":"Delisted_component__1NVb-"};